var _path, _circle, _circle2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fe3155",
    d: "M16,5.787c-0.308-0.744-0.47-1.134-0.778-1.879l-2.276-0.854l-0.854-2.276 C11.348,0.47,10.957,0.308,10.213,0L8,1.006L5.787,0C5.043,0.308,4.652,0.47,3.908,0.778L3.054,3.054L0.778,3.908 C0.47,4.652,0.308,5.042,0,5.787L1.006,8L0,10.213c0.308,0.744,0.47,1.134,0.778,1.879l2.276,0.854l0.854,2.276 C4.652,15.53,5.043,15.692,5.787,16L8,14.994L10.213,16c0.744-0.308,1.134-0.47,1.879-0.778l0.854-2.276l2.276-0.854 c0.308-0.744,0.47-1.134,0.778-1.879L14.994,8L16,5.787z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 1.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 1.5,
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.412,
    height: 1.901,
    x: 3.294,
    y: 7.049,
    fill: "#fff",
    transform: "rotate(-45.001 8 8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.8f80b5a0662481ab04b393a570f4a199.svg";
export { ForwardRef as ReactComponent };